// extracted by mini-css-extract-plugin
export default {"wrapper":"FileUpload_wrapper__r4ZdF","file":"FileUpload_file__TKM9Q","small":"FileUpload_small__lUCBe","big":"FileUpload_big__1Ncy0"};